import {fromPairs} from 'lodash'
import {ensureList} from './typing'
import {MyCheckout_me_checkout} from '../contexts/_gql-types/MyCheckout'


type Tuple = [string, number]

export function getCartQuantityMap(cart?: MyCheckout_me_checkout, variant_ids?: string[]) {
  let pairs = ensureList(cart?.lines).map<Tuple>((line) => [
    line.variant.id,
    line.quantity,
  ])

  if (variant_ids != null) {
    pairs = pairs.filter(([id]) => variant_ids.includes(id))
  }

  return fromPairs(pairs)
}
